import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { TokenService } from '../service/token.service';
import { SpinnerService } from '../service/spinner.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(public auth: TokenService, public loaderService: SpinnerService) { }
  private count: any = 0;
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.count < 0) {
      this.count = 0;
    }
    this.count++;
    if (request.url.indexOf('api/cronjob/run') !== -1) {
      this.count = 0;
      this.loaderService.displayLoader(false);
    }
    if (this.count === 1) {
      this.loaderService.displayLoader(true);
    }

    if (this.auth.isLogin()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.auth.getToken()}`
        }
      });
    }


    return next
      .handle(request)
      .catch((err: any) => {
        this.count--;
        if (this.count === 0) {
          this.loaderService.displayLoader(false);

        }
        return Observable.throw(err);
      })
      .do(event => {
        if (event instanceof HttpResponse) {
          this.count--;
          if (this.count === 0) {
            this.loaderService.displayLoader(false);

          }
        }

      });


  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/service/token.interceptor.ts